export const layoutConfiguration = [
  {
    version: 'L1',
    components: [
      { name: 'menu-page-header', version: 'cv1' },
      { name: 'loyalty-card', version: 'cv1' },
      { name: 'date-picker', version: 'cv1' },
      { name: 'outlet-list', version: 'cv2' },
      { name: 'recommended-menu-item-card', version: 'cv1' },
      { name: 'menu-item-card', version: 'cv1' },
    ],
  },
  {
    version: 'L2',
    components: [
      { name: 'menu-page-header', version: 'cv1' },
      { name: 'loyalty-card', version: 'cv2' },
      { name: 'date-picker', version: 'cv1' },
      { name: 'newly-launched-outlets', version: 'cv1' },
      { name: 'outlet-list', version: 'cv1' },
      { name: 'menu-category-section', version: 'cv1' },
      { name: 'recommended-menu-item-card', version: 'cv2' },
      { name: 'menu-item-card', version: 'cv2' },
    ],
  },
  {
    version: 'L3',
    components: [
      { name: 'menu-page-header', version: 'cv1' },
      { name: 'brand-promotion', version: 'cv1' },
      { name: 'date-picker', version: 'cv1' },
    ],
  },
  {
    version: 'L4',
    components: [
      { name: 'menu-page-header', version: 'cv1' },
      { name: 'date-picker', version: 'cv1' },
      { name: 'menu-page', version: 'cv4' },
      { name: 'recommended-menu-item-card', version: 'cv3' },
      { name: 'menu-item-card', version: 'cv3' },
      { name: 'menu-modal', version: 'cv2' },
      { name: 'previous-order-menu-item-card', version: 'cv2' },
      { name: 'material-elements', version: 'cv2' },
      { name: 'view-cart-popover', version: 'cv2' },
      { name: 'page-header', version: 'cv2' },
      { name: 'loyalty-card-mini', version: 'cv3' },
      { name: 'deal-card', version: 'cv2' },
      { name: 'guest-coupon-card', version: 'cv2' },
      { name: 'special-card', version: 'cv2' },
      { name: 'item-detail-popup', version: 'cv2' },
      { name: 'item-addon-popup', version: 'cv2' },
      { name: 'menu-item-reward-card', version: 'cv1' },
    ],
  },
  {
    version: 'L5',
    components: [
      { name: 'menu-page-header', version: 'cv1' },
      { name: 'menu-page', version: 'cv5' },
      { name: 'recommended-menu-item-card', version: 'cv4' },
      { name: 'menu-item-card', version: 'cv5' },
      { name: 'menu-modal', version: 'cv2' },
      { name: 'previous-order-menu-item-card', version: 'cv2' },
      { name: 'material-elements', version: 'cv2' },
      { name: 'view-cart-popover', version: 'cv2' },
      { name: 'page-header', version: 'cv2' },
      { name: 'loyalty-card-mini', version: 'cv3' },
      { name: 'deal-card', version: 'cv2' },
      { name: 'guest-coupon-card', version: 'cv2' },
      { name: 'special-card', version: 'cv2' },
      { name: 'item-detail-popup', version: 'cv3' },
      { name: 'item-addon-popup', version: 'cv2' },
      { name: 'menu-item-reward-card', version: 'cv1' },
    ],
  },
  {
    version: 'L6',
    components: [
      { name: 'menu-page-header', version: 'cv2' },
      { name: 'date-picker', version: 'cv1' },
      { name: 'menu-page', version: 'cv6' },
      { name: 'bottom-nav-bar', version: 'cv3' },
      { name: 'recommended-menu-item-card', version: 'cv5' },
      { name: 'menu-item-card', version: 'cv6' },
      { name: 'menu-modal', version: 'cv2' },
      { name: 'previous-order-menu-item-card', version: 'cv3' },
      { name: 'material-elements', version: 'cv4' },
      { name: 'view-cart-popover', version: 'cv3' },
      { name: 'cart-header', version: 'cv2' },
      { name: 'cart-footer', version: 'cv2' },
      { name: 'page-header', version: 'cv3' },
      { name: 'order-page-header', version: 'cv3' },
      { name: 'loyalty-card', version: 'cv10' },
      { name: 'loyalty-card-mini', version: 'cv6' },
      { name: 'deal-card', version: 'cv2' },
      { name: 'guest-coupon-card', version: 'cv3' },
      { name: 'special-card', version: 'cv3' },
      { name: 'brand-watermark', version: 'cv1' },
      { name: 'popup', version: 'cv2' },
      { name: 'item-addon-popup', version: 'cv3' },
      { name: 'additional-charges-popup', version: 'cv2' },
      { name: 'reward-program', version: 'cv6' },
      { name: 'reward-program-tier-card', version: 'cv5' },
      { name: 'permissions-privacy-page', version: 'cv3' },
      { name: 'about-us-page', version: 'cv3' },
      { name: 'confirmation-reward-points', version: 'cv3' },
      { name: 'order-summary-card', version: 'cv3' },
    ],
  },
  {
    version: 'L7',
    components: [
      { name: "loyalty-card", version: "cv11" },
      { name: "item-detail-popup", version: "cv1" },
      { name: "item-addon-popup", version: "cv1" },
      { name: "account-page", version: "cv2" },
      { name: 'menu-page', version: 'cv7' },
      { name: "page-header", version: "cv1" },
    ],
  },
  {
    version: 'L8',
    components: [
      { name: 'menu-category-section', version: 'cv2' },
      { name: 'menu-category-card', version: 'cv4' },
      { name: 'menu-item-card', version: 'cv7' },
      { name: 'recommended-menu-item-card', version: 'cv7' },
      { name: 'site-menu-page', version: 'cv2' },
      { name: 'site-locations-page', version: 'cv2' },
      // Item customize/details: cv2 embeds addon flow — do not use L7's v1 pair.
      { name: 'item-detail-popup', version: 'cv2' },
      { name: 'item-addon-popup', version: 'cv2' },
    ],
  },
];
